import React, { useRef, useEffect } from "react";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import Loading from "../../../InstagramInsights/components/Loading/Loading";
import CompetitorByHashtagsChart from "./CompetitorByHashtagsChart";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";

function CompetitorByHashtags(props) {
    let filteredData = props.data;

    let competitorAccountList = props.competitorList;
    const widgetContainerRef = useRef();

    useEffect(() => {
        if (props.isCompPage) {
            props.setSelectedCompetitorAccount(competitorAccountList[0]);
        }
    }, [props.selectedCompetitors]);

    if (props.isCompPage) {
        if (props.selectedCompetitors.length > 0) {
            competitorAccountList = competitorAccountList.filter((ac) => props.selectedCompetitors.includes(ac.research_query_id));
        }
    }
    const chartEl = useRef();

    let nodata = (props.data?.nodata && !props.loading) || props.data?.totalHashtags === 0 || !props.data?.data;

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downloadCSV },
                    { name: "PNG", downloadFn: downloadPNG, showLoader: true },
                ]}
            />
        );
    };

    const downloadCSV = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        // let data = [["Competitor Name","Hashtag", "Count"]];
        let downLoadingData = [["Competitor Name", "Hashtag", "Count"]];

        props.data?.data.forEach((obj) => {
            let d = [];
            obj.data.forEach((ele) => {
                d.push([obj.name, ele.name, ele.y]);
            });
            // let d = [obj.name, obj.data?.[0]?.y || 0];
            downLoadingData.push(...d);
        });
        // props.data.forEach((d) => {
        //     data.push([d.key, d.doc_count]);
        // });

        downloadCSVData(downLoadingData, props.widget?.name || "Competitor Hashtags");
    };

    const downloadPNG = (cb) => {
        html2canvas(chartEl.current, { backgroundColor: "white", allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, props.widget?.name || "Competitor Hashtags");
        });
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    name={props.widget?.name || "Competitor Hashtags"}
                    info="This chart will show the Top 5 hastags of your competitors for the posts in the selected time range."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isPublic && renderDownloadButton(nodata)}
                    <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!nodata && <CustomCheckBox checked={props.showLegend} onClick={props.changeShowLegend} label="Show Legends" />}
                    {!nodata && <CustomCheckBox checked={props.showGridLines} onClick={props.changeShowGridLines} label="Show Gridlines" />}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                <div className="chart-area">
                    {!nodata ? (
                        props.loading ? (
                            <Loading />
                        ) : (
                            <CompetitorByHashtagsChart
                                widgetContainerRef={props.isCompPage ? widgetContainerRef : props.widgetContainerRef}
                                data={props.data?.data}
                                isCompPage={props.isCompPage}
                                showGridLines={props.showGridLines}
                                showLegend={props.showLegend}
                            />
                        )
                    ) : (
                        <NoData />
                    )}
                </div>
            </div>
        </>
    );

    return props.isCompPage ? (
        <div className={`dashboard-widget-container ${props.expandWidget ? "maximize-widget" : ""}`} ref={widgetContainerRef}>
            {elements}
        </div>
    ) : (
        <>{elements}</>
    );
}

export default CompetitorByHashtags;
